module.exports = __webpack_public_path__ + "img/atok_import_001.4d0dcfee.png";